module.exports = __webpack_public_path__ + "static/media/Engy.7129139d.jpg";